import { useEffect } from 'react';

const BASE_TITLE = 'CampanhaFlow';
const DEFAULT_TITLE = 'CampanhaFlow — WhatsApp para Campanhas Eleitorais';

interface PageSEOOptions {
  title: string;
  description?: string;
  ogImage?: string;
  canonical?: string;
}

function setMeta(selector: string, attr: string, value: string) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

export function usePageSEO({ title, description, ogImage, canonical }: PageSEOOptions) {
  useEffect(() => {
    const fullTitle = title === BASE_TITLE ? DEFAULT_TITLE : `${title} | ${BASE_TITLE}`;
    document.title = fullTitle;

    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
      setMeta('meta[name="twitter:description"]', 'content', description);
    }

    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);

    const url = canonical || window.location.href.split('?')[0];
    setMeta('meta[property="og:url"]', 'content', url);
    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) canonicalEl.setAttribute('href', url);

    if (ogImage) {
      setMeta('meta[property="og:image"]', 'content', ogImage);
      setMeta('meta[name="twitter:image"]', 'content', ogImage);
    }

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[property="og:title"]', 'content', DEFAULT_TITLE);
      setMeta('meta[name="twitter:title"]', 'content', DEFAULT_TITLE);
    };
  }, [title, description, ogImage, canonical]);
}
